import './i18n';

import './app';
import './xdr';
import './class.Common';
import './class.OrderProductModifier';
import './class.OrderProductSizeModifier';
import './class.OrderProductModifierGroup';
import './class.OrderProduct';
import './class.OrderProducts';
import './class.OrderPaymentProcessors';
import './class.Order';
import './class.OperatingHours';
import './class.Location';
import './class.Customer';
import './class.CustomerAddress';
import './class.MenuItem';
import './class.MapsService';
import './api.Customer';
import './api.Locations';
import './api.Menu';
import './api.Order';
import './api.MapsService';
import './UI';
import './api.Analytics';
import './inspectlet-tracking';
import './google-analytics';
import './google-analytics-4';
import './google-tag-manager';
import './google-adwords';
import './facebook-pixel';
import './snap-pixel';
import './segment-analytics';
import './Logger';
import './GroupTabLogger';

import './dev';

// TODO: code spliting like so (impossible with php stuff)
// if (!process.env.production) {
//     import('./dev');
// }
